(function(m, o) {
  "use strict";
  typeof module == "object" && typeof module.exports == "object" ? module.exports = o(m, !0) : typeof define == "function" && define.amd ? define("vFramePlayer", [], function() {
      return o(m)
  }) : m.vFramePlayer = o(m)
}
)(typeof window != "undefined" ? window : this, function(m, o) {
  "use strict";
  var h = function(e) {
      if (e) {
          for (var r in this.dom = e.dom,
          this.startFrame = 0,
          this.endFrame = e.imgArr.length - 1,
          this.curFrame = 0,
          this.prevFrame = 0,
          this.fps = e.fps || 25,
          this.useCanvas = !!e.useCanvas,
          this.loop = e.loop || 0,
          this.yoyo = !!e.yoyo,
          this._imgObjArr = [],
          this._events = {},
          this._isPng = !0,
          this._isPlay = !1,
          this._times = 0,
          this._asc = !0,
          this._temp = {},
          e.imgArr) {
              var t = new Image;
              t.src = e.imgArr[r],
              this._imgObjArr.push(t)
          }
          this.init()
      } else
          console.log("\u8BF7\u8BBE\u7F6E\u53C2\u6570\uFF01")
  }
    , c = function(e, r) {
      e.complete ? r() : e.onload = function() {
          r()
      }
  };
  return h.prototype = {
      init: function() {
          var e = this;
          if (this.dom.textContent = "",
          e.useCanvas) {
              var r = document.createElement("canvas");
              r.width = r.height = 0,
              r.style.width = r.style.height = "100%",
              this.ctx = r.getContext("2d"),
              this.dom.appendChild(r),
              c(this._imgObjArr[0], function() {
                  e._isPng = /(\.png(\?|$))|(image\/png;base64)/.test(e._imgObjArr[0].src),
                  e.width = r.width = e._imgObjArr[0].width,
                  e.height = r.height = e._imgObjArr[0].height
              })
          } else {
              e.mc = document.createElement("div"),
              e.mc.setAttribute("class", "mc"),
              e.mc.style.width = e.mc.style.height = "100%",
              this.dom.appendChild(e.mc);
              for (var t = 0; t < this._imgObjArr.length; t++)
                  this._imgObjArr[t].style.opacity = 0,
                  this._imgObjArr[t].style.position = "absolute",
                  this._imgObjArr[t].style.width = this._imgObjArr[t].style.height = "100%",
                  this._imgObjArr[t].style.top = this._imgObjArr[t].style.left = 0,
                  e.mc.appendChild(this._imgObjArr[t])
          }
      },
      set: function(e, r) {
          var t = this._temp;
          if (arguments.length === 1 && typeof arguments[0] == "object")
              for (var s in arguments[0])
                  this[s] = arguments[0][s];
          arguments.length === 2 && (this[arguments[0]] = arguments[1]),
          e === "useCanvas" && this.init(),
          e === "fps" && this._isPlay && (clearInterval(this._interval),
          this._process(t.onUpdate, t.onComplete)),
          e === "startFrame" && (this._isPlay || (this.curFrame = this.startFrame))
      },
      get: function(e) {
          return this[e]
      },
      play: function(e, r, t) {
          if (!this._isPlay) {
              var s, n, a = this, l = 0;
              for (var i in arguments)
                  switch (typeof arguments[i]) {
                  case "number":
                      l == 0 ? (a.set("startFrame", arguments[i]),
                      l++) : a.set("endFrame", arguments[i]);
                      break;
                  case "object":
                      arguments[i].onComplete && (s = arguments[i].onComplete),
                      delete arguments[i].onComplete,
                      arguments[i].onUpdate && (n = arguments[i].onUpdate),
                      delete arguments[i].onUpdate,
                      a.set(arguments[i])
                  }
              a._temp.onComplete = s,
              a._temp.onUpdate = n,
              a._asc = a.startFrame < a.endFrame,
              a._isPlay || this.trigger("play"),
              this._process(n, s)
          }
      },
      _process: function(e, r) {
          var t = this;
          this._interval = setInterval(function() {
              t._imgObjArr[t.curFrame].complete && (t.useCanvas ? (t._isPng && t.ctx.clearRect(0, 0, t.width, t.height),
              t.ctx.drawImage(t._imgObjArr[t.curFrame], 0, 0, t.width, t.height)) : (t.mc.childNodes[t.prevFrame].style.opacity = 0,
              t.mc.childNodes[t.curFrame].style.opacity = 1),
              t.prevFrame = t.curFrame,
              t.trigger("update", t.curFrame, t._times + 1, t._asc),
              e && e(t.curFrame, t._times + 1, t._asc),
              t.curFrame != t.endFrame && t.curFrame != t.startFrame || !t._isPlay || t._temp.repeat ? (t._asc ? t.curFrame++ : t.curFrame--,
              t._isPlay = !0,
              t._temp.repeat = !1) : t.loop && (t._times + 1 < t.loop || t.loop == -1) ? (t.yoyo ? (t._asc ? t.curFrame = Math.max(t.startFrame, t.endFrame) - 1 : t.curFrame = Math.min(t.startFrame, t.endFrame) + 1,
              t._asc = !t._asc) : (t._temp.repeat = !0,
              t._asc ? t.curFrame = Math.min(t.startFrame, t.endFrame) : t.curFrame = Math.max(t.startFrame, t.endFrame)),
              t._times++) : (t.stop(),
              r && r()))
          }, 1e3 / this.fps)
      },
      goto: function(e) {
          var r = this;
          this.curFrame = e,
          c(this._imgObjArr[this.curFrame], function() {
              r.useCanvas ? (r._isPng && r.ctx.clearRect(0, 0, r.width, r.height),
              r.ctx.drawImage(r._imgObjArr[r.curFrame], 0, 0, r.width, r.height)) : (r.mc.childNodes[r.prevFrame].style.opacity = 0,
              r.mc.childNodes[r.curFrame].style.opacity = 1),
              r.trigger("update", r.curFrame, r._times + 1, r._asc)
          })
      },
      pause: function() {
          this._isPlay = !1,
          this.trigger("pause"),
          clearInterval(this._interval)
      },
      stop: function() {
          this._isPlay = !1,
          this.trigger("stop"),
          this.curFrame = this.startFrame,
          clearInterval(this._interval),
          this._times = 0
      },
      on: function(e, r) {
          e = e.split(" ");
          for (var t = 0; t < e.length; ++t)
              this._events[e[t]] || (this._events[e[t]] = []),
              this._events[e[t]].unshift(r);
          return this
      },
      one: function(e, r) {
          var t = function() {
              r(),
              this.off(e, t)
          };
          return this.on(e, t)
      },
      off: function(e, r) {
          if (e) {
              e = e.split(" ");
              for (var t = this._events, s = 0; s < e.length; ++s)
                  if (t[e[s]])
                      if (r)
                          for (var n = t[e[s]].length - 1; n >= 0; --n)
                              t[e[s]][n] == r && t[e[s]].splice(n, 1);
                      else
                          t[e[s]] = []
          } else
              this._events = {};
          return this
      },
      trigger: function() {
          var e = Array.prototype.shift.call(arguments);
          e = e.split(" ");
          for (var r = 0; r < e.length; ++r)
              if (this._events[e[r]])
                  for (var t = this._events[e[r]].length - 1; t >= 0; --t)
                      try {
                          this._events[e[r]][t].apply(this, arguments)
                      } catch (s) {
                          console.log(s)
                      }
          return this
      },
      destroy: function() {
          clearInterval(this._interval),
          this.off()
      }
  },
  h
});
